import { encode } from 'base-64';
import { storageDataKeys } from './cacheTypes';
export const cacheResponseData = (response) => {
    for (let key = 0; key < storageDataKeys.length; key++) {
        if (response.config.method === 'get' &&
            (response.request?.responseURL?.endsWith(storageDataKeys[key]) ||
                response.request?.responseURL?.endsWith(`${storageDataKeys[key]}/Get`)) &&
            response.data) {
            localStorage.setItem(storageDataKeys[key], JSON.stringify(response.data));
            window.dispatchEvent(new Event('storage'));
        }
    }
};
const getImageFile = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (ev) => {
            resolve(ev.target?.result);
        };
        reader.onerror = reject;
    });
};
export const cacheImage = async (file, type) => {
    const blob = await (await fetch(file)).blob();
    const imageFile = await getImageFile(blob);
    const base64Image = encode(imageFile);
    localStorage.setItem(type, JSON.stringify(base64Image));
    window.dispatchEvent(new Event('storage'));
};
